"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.default = {
    'tutorial.form.basicInfo': 'Informacje podstawowe',
    'tutorial.form.name': 'Nazwa szkolenia',
    'tutorial.form.assistant': 'Asystent',
    'tutorial.form.namePlaceholder': 'Wprowadź tytuł kursu',
    'tutorial.form.avatar': 'Avatar prowadzący',
    'tutorial.form.selectAvatar': 'Wybierz avatar…',
    'tutorial.form.company': 'Firma / Przypisanie',
    'tutorial.form.category': 'Kategoria poradnika',
    'tutorial.form.no_cat': 'Brak kategorii',
    'tutorial.form.logo': 'Logo poradnika',
    'tutorial.form.selectCompany': 'Wybierz firmę...',
    'tutorial.form.description': 'Opis ogólny',
    'tutorial.form.descriptionPlaceholder': 'Opisz krótko czego dotyczy to szkolenie...',
    'tutorial.form.introText': 'Wstęp dla uczestnika',
    'tutorial.form.introTextPlaceholder': 'Napisz tekst wprowadzający, witający uczestnika...',
    'tutorial.form.active': 'Aktywne',
    'tutorial.form.steps': 'Kroki poradnika',
    'tutorial.form.step': 'Krok',
    'tutorial.form.stepCount': 'Krok {current} / {total}',
    'tutorial.form.start': 'Start',
    'tutorial.form.addStep': 'Dodaj krok',
    'tutorial.form.stepName': 'Nazwa kroku',
    'tutorial.form.stepNamePlaceholder': 'np. Wprowadzenie',
    'tutorial.form.stepDescription': 'Opis kroku',
    'tutorial.form.stepDescriptionPlaceholder': 'Wprowadź opis kroku (opcjonalnie)',
    'tutorial.form.selectStep': 'Wybierz krok...',
    'tutorial.form.sections': 'Sekcje',
    'tutorial.form.sectionsCount': '{count} sekcji',
    'tutorial.form.section': 'Sekcja',
    'tutorial.form.sectionName': 'Nazwa sekcji',
    'tutorial.form.sectionNamePlaceholder': 'Tytuł sekcji',
    'tutorial.form.sectionContent': 'Treść',
    'tutorial.form.sectionIntro': 'Wstęp do sekcji',
    'tutorial.form.sectionIntroPlaceholder': 'Wprowadzenie do sekcji…',
    'tutorial.form.sectionPrompt': 'Prompt (wiedza dla sekcji)',
    'tutorial.form.sectionPromptPlaceholder': 'Dostarczyć wiedzę lub wskazówki dla tej sekcji...',
    'tutorial.form.addKnowledge': 'Dodaj wiedzę',
    'tutorial.form.selectedKnowledge': 'Wybrana wiedza',
    'tutorial.form.files': 'Zdjęcie / Screen',
    'tutorial.form.screenshot': 'Zdjęcie / Screen',
    'tutorial.form.screenshotPlaceholder': 'Nie wybrano pliku',
    'tutorial.form.video': 'Wideo (MP4)',
    'tutorial.form.videoPlaceholder': 'Nie wybrano pliku',
    'tutorial.form.screenshotMini': 'Miniatura zdjęcia / screena',
    'tutorial.form.screenshotMiniPlaceholder': 'Nie wybrano pliku',
    'tutorial.form.videoMini': 'Miniatura wideo',
    'tutorial.form.videoMiniPlaceholder': 'Nie wybrano pliku',
    'tutorial.form.addSection': 'Dodaj sekcję',
    'tutorial.form.source.label': 'Źródło',
    'tutorial.form.source.ai': 'Generowane przez AI',
    'tutorial.form.source.file': 'Wygenerowane szkolenie – dane statyczne',
    'tutorial.form.sourceFile.label': 'Plik źródłowy',
    'tutorial.form.sourceFile.placeholder': 'Wybierz plik źródłowy…',
    'tutorial.form.scanPages.label': 'Zakres stron indeksu / spisu treści',
    'tutorial.form.scanSourceFile': 'Skanuj plik źródłowy i wypełnij formularz szkolenia',
    'tutorial.form.scanSourceFileDescription': 'AI przeanalizuje wprowadzone już dane i uzupełni brakującą strukturę szkolenia (sekcje i kroki).',
    'tutorial.form.regenerateFromPdf': 'Wygeneruj ponownie z pliku źródłowego',
    'tutorial.form.regenerateFromPdf.title': 'Wygenerować ponownie szkolenie z pliku źródłowego?',
    'tutorial.form.regenerateFromPdf.confirm': 'Treść szkolenia zostanie wygenerowana ponownie na podstawie pliku źródłowego i może zastąpić istniejącą treść. Czy kontynuować?',
    'tutorial.form.tutorialGoal': 'Cel szkolenia',
    'tutorial.form.tutorialGoalPlaceholder': 'Opisz, co uczestnik powinien umieć po ukończeniu tego szkolenia...',
    'tutorial.form.backToList': 'Wróć do listy szkoleń',
    'tutorial.form.loading': 'Wczytywanie…',
    'tutorial.form.editTitle': 'Edytuj poradnik',
    'tutorial.form.createTitle': 'Nowy poradnik',
    'tutorial.form.save': 'Zapisz poradnik',
    'tutorial.form.update': 'Zaktualizuj poradnik',
    'tutorial.form.publish': 'Opublikuj',
    'tutorial.form.previous': 'Wstecz',
    'tutorial.form.next': 'Dalej',
    'tutorial.form.basicInfoShort': 'Informacje podstawowe',
    'tutorial.form.tasks': 'Zadania',
    'tutorial.form.addTask': 'Dodaj zadanie',
    'tutorial.form.taskTitlePlaceholder': 'Tytuł zadania',
    'tutorial.form.taskDescPlaceholder': 'Opis (opcjonalnie)',
    'tutorial.form.attachments': 'Załączniki',
    'tutorial.form.addFile': 'Dodaj plik',
    'tutorial.form.sectionFileMiniature': 'Miniatura pliku',
    'tutorial.form.sectionFileRequired': 'Wybierz plik przed dodaniem.',
    'tutorial.form.examplePrompts_1': 'Stwórz szkolenie dla początkujących o podstawach jazdy na nartach, z krokami, sekcjami i zadaniami do wykonania',
    'tutorial.form.examplePrompts_2': 'Przepisz opis i tekst wprowadzający tak, aby pasowały do celu szkolenia',
    'tutorial.form.examplePrompts_3': 'Dodaj krótką listę zadań do wykonania do każdej sekcji tego szkolenia',
    'tutorial.form.scanNeedsData': 'Uzupełnij przynajmniej nazwę, cel lub opis (albo dodaj kroki), aby AI miało co rozwinąć',
    'tutorial.form.start.title': 'Jak chcesz zacząć?',
    'tutorial.form.start.onboarding.title': 'Kreator AI',
    'tutorial.form.start.onboarding.description': 'Odpowiedz na krótką, prowadzoną ankietę o swoim szkoleniu. AI ukształtuje kurs na podstawie Twoich odpowiedzi.',
    'tutorial.form.start.onboarding.action': 'Rozpocznij ankietę',
    'tutorial.form.start.form.title': 'Pusty poradnik',
    'tutorial.form.start.form.description': 'Wypełnij formularz samodzielnie, zeskanuj plik źródłowy lub poproś o pomoc asystenta AI. Ankietę możesz dodać później z nagłówka formularza.',
    'tutorial.form.start.form.action': 'Przejdź do formularza',
    'tutorial.form.start.form.how.title': 'Jak to działa',
    'tutorial.form.start.form.how.step1': 'Nadajesz nazwę, wybierasz kategorię, dodajesz opis i logo poradnika.',
    'tutorial.form.start.form.how.step1.title': 'Podstawowe informacje',
    'tutorial.form.start.form.how.step2': 'Zakładasz kolejne kroki kursu, a w każdym z nich sekcje – ich kolejność ustalasz sam.',
    'tutorial.form.start.form.how.step2.title': 'Kroki i sekcje',
    'tutorial.form.start.form.how.step3': 'Do sekcji dopisujesz wprowadzenie i dołączasz pliki, zdjęcia oraz wideo.',
    'tutorial.form.start.form.how.step3.title': 'Treść i materiały',
    'tutorial.form.start.form.how.step4': 'Dodajesz zadania do wykonania, które uczestnik odhacza w trakcie nauki.',
    'tutorial.form.start.form.how.step4.title': 'Zadania dla uczestników',
    'tutorial.form.start.how.title': 'Jak to działa',
    'tutorial.form.start.how.step1': 'Podstawy kursu, odbiorcy, struktura i czas trwania, styl nauczania, materiały, model nauki i certyfikacja.',
    'tutorial.form.start.how.step1.title': 'Krótka ankieta krok po kroku',
    'tutorial.form.start.how.step2': 'Są dołączane do kursu, więc w każdej chwili możesz do nich wrócić i je zmienić.',
    'tutorial.form.start.how.step2.title': 'Odpowiedzi zapisują się razem ze szkoleniem',
    'tutorial.form.start.how.step3': 'Przy każdym generowaniu treści – w asystencie AI i przy skanowaniu pliku źródłowego – struktura, głębokość, ton i ćwiczenia odpowiadają Twoim wyborom.',
    'tutorial.form.start.how.step3.title': 'AI traktuje je jako instrukcje',
    'tutorial.scanned': 'Szkolenie zostało zeskanowane, a formularz uzupełniony',
    'tutorial.scanFailed': 'Nie udało się zeskanować szkolenia',
    'tutorial.form.expireAt': 'Data wygaśnięcia',
    'tutorial.form.scanKnowledge.label': 'Lub użyj wpisu z bazy wiedzy jako źródła skanowania',
    'tutorial.form.scanKnowledge.none': 'Nie wybrano wpisu z bazy wiedzy',
    'tutorial.form.source.ai.description': 'Treść szkolenia zostanie wygenerowana przez AI w czasie rzeczywistym.',
    'tutorial.form.source.file.description': 'Wgraj plik źródłowy (np. PDF). Jego spis treści zostanie zeskanowany, aby zbudować szkolenie.',
    'tutorial.form.scanSourceFile.description.ai': 'AI przeanalizuje wprowadzone już dane i uzupełni brakującą strukturę szkolenia (sekcje i kroki).',
    'tutorial.form.scanSourceFile.description.file': 'Plik źródłowy zostanie zeskanowany, aby wygenerować pełną strukturę szkolenia oraz jego treść (sekcje, kroki i teksty).',
    'tutorial.form.onboardingAttached': 'Dodany onboarding',
    'tutorial.form.scanProgress.step': 'Krok',
    'tutorial.form.scanProgress.section': 'Sekcja',
    'tutorial.form.scanProgress.reading': 'Odczytywanie pliku źródłowego...',
    'tutorial.form.scanProgress.index': 'Analiza struktury i planowanie sekcji...',
    'tutorial.form.scanProgress.content': 'Pisanie treści sekcji',
    'tutorial.form.scanProgress.todos': 'Tworzenie zadań',
    'tutorial.form.source_pages': 'Strony źródłowe sekcji',
    'tutorial.form.todoItems': 'Zadania',
    'tutorial.form.todoItemPlaceholder': 'Tytuł zadania',
    'tutorial.form.todoItemDescriptionPlaceholder': 'Opis (opcjonalnie)',
    'tutorial.form.addTodoItem': 'Dodaj zadanie',
    'tutorial.form.removeTodoItem': 'Usuń zadanie',
    'tutorial.form.todoDescription': 'Zarządzaj listą zadań dla tej sekcji',
    'tutorial.form.noTodoItems': 'Ta sekcja nie ma jeszcze zadań do wykonania.',
    'tutorial.form.avatarPlaceholder': 'Wybierz avatar prowadzący',
    'tutorial.form.updatedFromAI': 'Formularz zaktualizowany przez asystenta AI',
    'tutorial.form.source': 'Źródło danych szkolenia',
    // Onboarding wizard
    'tutorial.form.onboarding.title': 'Utwórz poradnik',
    'tutorial.form.onboarding.button': 'Onboarding',
    'tutorial.form.onboarding.submit': 'Generuj kurs',
    'tutorial.form.onboarding.stepLabel': 'Krok',
    'tutorial.form.onboarding.step': 'Krok',
    'tutorial.form.onboarding.of': 'z',
    'tutorial.form.onboarding.step1': 'Informacje podstawowe',
    'tutorial.form.onboarding.step1.hint': 'Nazwa, cel i opis kursu',
    'tutorial.form.onboarding.step2': 'Odbiorcy',
    'tutorial.form.onboarding.step2.hint': 'Poziom, branża i grupa docelowa',
    'tutorial.form.onboarding.step3': 'Parametry kursu',
    'tutorial.form.onboarding.step3.hint': 'Czas, liczba kroków i sekcji',
    'tutorial.form.onboarding.step4': 'Styl kursu',
    'tutorial.form.onboarding.step4.hint': 'Styl prowadzenia i ton',
    'tutorial.form.onboarding.step5': 'Materiały do wygenerowania',
    'tutorial.form.onboarding.step5.hint': 'Co ma przygotować AI',
    'tutorial.form.onboarding.step6': 'Model nauki',
    'tutorial.form.onboarding.step6.hint': 'Proporcje teorii, ćwiczenia, zaliczenie',
    'tutorial.form.onboarding.step7': 'Certyfikacja',
    'tutorial.form.onboarding.step7.hint': 'Certyfikat i próg zaliczenia',
    'tutorial.form.onboarding.name': 'Nazwa kursu',
    'tutorial.form.onboarding.category': 'Kategoria',
    'tutorial.form.onboarding.goals': 'Cel kursu',
    'tutorial.form.onboarding.description': 'Opis kursu (max 2000 znaków)',
    'tutorial.form.onboarding.level': 'Poziom wiedzy',
    'tutorial.form.onboarding.participants': 'Liczba uczestników',
    'tutorial.form.onboarding.participants.1-10': '1-10',
    'tutorial.form.onboarding.participants.10-50': '10-50',
    'tutorial.form.onboarding.participants.50-200': '50-200',
    'tutorial.form.onboarding.participants.200-1000': '200-1000',
    'tutorial.form.onboarding.participants.1000+': '1000+',
    'tutorial.form.onboarding.industries': 'Branża',
    'tutorial.form.onboarding.targetGroups': 'Grupa docelowa',
    'tutorial.form.onboarding.totalHours': 'Łączny czas kursu',
    'tutorial.form.onboarding.modulesCount': 'Liczba kroków',
    'tutorial.form.onboarding.lessonsPerModule': 'Liczba sekcji w kroku',
    'tutorial.form.onboarding.lessonMinutes': 'Średni czas trwania sekcji',
    'tutorial.form.onboarding.intensity': 'Intensywność',
    'tutorial.form.onboarding.styles': 'Styl prowadzenia',
    'tutorial.form.onboarding.tone': 'Ton komunikacji',
    'tutorial.form.onboarding.materials': 'AI ma stworzyć',
    'tutorial.form.onboarding.aiAvatar': 'Awatar AI',
    'tutorial.form.onboarding.slides': 'Generuj slajdy',
    'tutorial.form.onboarding.narration': 'Generuj narrację',
    'tutorial.form.onboarding.quizVideo': 'Generuj quiz video',
    'tutorial.form.onboarding.graphics': 'Generuj grafiki',
    'tutorial.form.onboarding.graphicsStyle': 'Styl grafik',
    'tutorial.form.onboarding.theoryPracticeRatio': 'Teoria ⟷ Praktyka',
    'tutorial.form.onboarding.exercisesCount': 'Ilość ćwiczeń',
    'tutorial.form.onboarding.caseStudiesCount': 'Ilość case studies',
    'tutorial.form.onboarding.finalProject': 'Projekt końcowy',
    'tutorial.form.onboarding.finalExam': 'Egzamin końcowy',
    'tutorial.form.onboarding.certificate': 'Certyfikat ukończenia',
    'tutorial.form.onboarding.passThreshold': 'Poziom zaliczenia',
    'tutorial.form.onboarding.numbered': 'Numerowany certyfikat',
    'tutorial.form.onboarding.qrVerification': 'Weryfikacja certyfikatu QR',
    'tutorial.form.onboarding.theory': 'Teoria',
    'tutorial.form.onboarding.practice': 'Praktyka',
    'tutorial.form.onboarding.selectAll': 'Zaznacz wszystkie',
    'tutorial.form.onboarding.deselectAll': 'Odznacz wszystkie',
    'tutorial.form.onboarding.optionHint': 'Wskaż opcję, aby zobaczyć, na co wpływa w kursie.',
    'tutorial.form.onboarding.info.name': 'Główny temat dla AI – pojawi się w nagłówku kursu, materiałach i na certyfikacie.',
    'tutorial.form.onboarding.info.desc': 'Najważniejsza wskazówka dla AI – im konkretniej opiszesz temat i zakres, tym trafniejszy konspekt i treści.',
    'tutorial.form.onboarding.info.category': 'Porządkuje kurs na liście szkoleń i w filtrach – nie zmienia generowanych treści.',
    'tutorial.form.onboarding.info.avatar': 'Avatar prowadzący kurs – jego styl, osobowość i wiedza wpływają na ton oraz treść generowanych materiałów.',
    'tutorial.form.onboarding.info.goals': 'Decyduje, na co AI położy nacisk: wiedzę, umiejętności, przygotowanie do testu czy efekt biznesowy.',
    'tutorial.form.onboarding.info.level': 'Ustala głębokość materiału, słownictwo i tempo – od czego AI zaczyna i co może pominąć.',
    'tutorial.form.onboarding.info.participants': 'Wpływa na formę ćwiczeń i sposób sprawdzania wiedzy.',
    'tutorial.form.onboarding.info.industries': 'AI dobiera do branży przykłady, case studies i słownictwo.',
    'tutorial.form.onboarding.info.targetGroups': 'Określa perspektywę kursu – czyje problemy rozwiązuje i jakie decyzje omawia.',
    'tutorial.form.onboarding.info.totalHours': 'Docelowa objętość kursu – AI dopasuje do niej ilość materiału w lekcjach.',
    'tutorial.form.onboarding.info.modulesCount': 'Liczba głównych modułów – tyle kroków powstanie w konspekcie i w menu kursu.',
    'tutorial.form.onboarding.info.lessonsPerModule': 'Liczba lekcji w każdym kroku. Więcej sekcji to mniejsze, bardziej szczegółowe porcje materiału.',
    'tutorial.form.onboarding.info.lessonMinutes': 'Długość pojedynczej lekcji – decyduje o ilości tekstu i liczbie zadań w sekcji.',
    'tutorial.form.onboarding.info.intensity': 'Ogólny charakter kursu – gęstość treści, liczba zadań i wymagania wobec uczestnika.',
    'tutorial.form.onboarding.info.styles': 'Sposób prowadzenia narracji i budowy lekcji – style można łączyć.',
    'tutorial.form.onboarding.info.tone': 'Sposób zwracania się do uczestnika – obowiązuje we wszystkich generowanych materiałach.',
    'tutorial.form.onboarding.info.materials': 'Każda zaznaczona pozycja to osobny materiał przygotowany przez AI – im więcej, tym dłużej trwa generowanie.',
    'tutorial.form.onboarding.info.theoryPracticeRatio': 'Bliżej teorii – AI więcej wyjaśnia. Bliżej praktyki – lekcje opierają się na zadaniach i przykładach.',
    'tutorial.form.onboarding.info.exercisesCount': 'Łączna liczba ćwiczeń w kursie – AI rozłoży je między sekcje.',
    'tutorial.form.onboarding.info.caseStudiesCount': 'Analizy realnych sytuacji z omówieniem, dodawane do wybranych kroków.',
    'tutorial.form.onboarding.info.finalProject': 'Uczestnik oddaje praktyczny projekt – AI przygotuje brief, wymagania i kryteria oceny.',
    'tutorial.form.onboarding.info.finalExam': 'Na końcu kursu AI wygeneruje test sprawdzający wiedzę z całego materiału.',
    'tutorial.form.onboarding.info.certificate': 'Wystawiany po zaliczeniu kursu – odblokowuje numerację, kod QR i próg zaliczenia.',
    'tutorial.form.onboarding.info.passThreshold': 'Minimalny wynik z testów i egzaminu potrzebny do zaliczenia kursu i otrzymania certyfikatu.',
    'tutorial.form.onboarding.info.numbered': 'Każdy certyfikat dostaje unikalny numer, łatwy do odnalezienia w rejestrze.',
    'tutorial.form.onboarding.info.qrVerification': 'Na certyfikacie pojawi się kod QR potwierdzający jego autentyczność.',
    'tutorial.form.onboarding.descs.goals.knowledge': 'więcej wyjaśnień, definicji i kontekstu, podsumowanie po każdej sekcji.',
    'tutorial.form.onboarding.descs.goals.skills': 'lekcje kończą się zadaniem do wykonania, instrukcje krok po kroku.',
    'tutorial.form.onboarding.descs.goals.certification': 'pytania kontrolne w trakcie kursu i jasne wymagania zaliczenia na końcu.',
    'tutorial.form.onboarding.descs.goals.process_implementation': 'treści ułożone jako procedury i checklisty do zastosowania w firmie.',
    'tutorial.form.onboarding.descs.goals.sales_increase': 'przykłady i ćwiczenia z sytuacji sprzedażowych, skrypty rozmów, obiekcje.',
    'tutorial.form.onboarding.descs.goals.company_automation': 'nacisk na narzędzia, scenariusze automatyzacji i oszczędność czasu.',
    'tutorial.form.onboarding.descs.goals.career_growth': 'materiał ukierunkowany na kompetencje, portfolio i kolejne kroki rozwoju.',
    'tutorial.form.onboarding.descs.goals.exam_preparation': 'powtórki, testy próbne i omówienie typowych pytań egzaminacyjnych.',
    'tutorial.form.onboarding.descs.levels.beginner': 'podstawy od zera, prosty język, dużo przykładów i definicji.',
    'tutorial.form.onboarding.descs.levels.intermediate': 'krótkie przypomnienie podstaw, nacisk na praktyczne zastosowania.',
    'tutorial.form.onboarding.descs.levels.advanced': 'bez podstaw – niuanse, optymalizacja i trudniejsze przypadki.',
    'tutorial.form.onboarding.descs.levels.expert': 'specjalistyczne słownictwo, strategie, analizy i przypadki brzegowe.',
    'tutorial.form.onboarding.descs.participants.1-10': 'zadania otwarte i projekty z indywidualną informacją zwrotną.',
    'tutorial.form.onboarding.descs.participants.10-50': 'mieszanka zadań otwartych i quizów, ćwiczenia w małych grupach.',
    'tutorial.form.onboarding.descs.participants.50-200': 'przewaga quizów i zadań zamkniętych, które łatwo sprawdzić.',
    'tutorial.form.onboarding.descs.participants.200-1000': 'ocena głównie automatyczna, materiały do samodzielnej nauki.',
    'tutorial.form.onboarding.descs.participants.1000+': 'kurs w pełni samoobsługowy – automatyczne testy bez ręcznego sprawdzania.',
    'tutorial.form.onboarding.descs.industries.b2b': 'przykłady z długiego procesu sprzedaży, pracy z klientem firmowym i umów.',
    'tutorial.form.onboarding.descs.industries.ecommerce': 'przykłady ze sklepów internetowych: koszyk, konwersja, obsługa zamówień.',
    'tutorial.form.onboarding.descs.industries.services': 'scenariusze obsługi klienta, umawiania wizyt i jakości usług.',
    'tutorial.form.onboarding.descs.industries.production': 'przykłady z procesów produkcyjnych, logistyki i kontroli jakości.',
    'tutorial.form.onboarding.descs.industries.accounting': 'przykłady z dokumentów, rozliczeń, terminów i przepisów.',
    'tutorial.form.onboarding.descs.industries.it': 'przykłady techniczne, projekty, wdrożenia i praca zespołów IT.',
    'tutorial.form.onboarding.descs.industries.education': 'przykłady ze szkół, szkoleń i pracy z kursantami.',
    'tutorial.form.onboarding.descs.industries.real_estate': 'przykłady z obrotu i zarządzania nieruchomościami, pracy z ofertami.',
    'tutorial.form.onboarding.descs.industries.medicine': 'przykłady z placówek medycznych, ostrożne podejście do treści specjalistycznych.',
    'tutorial.form.onboarding.descs.industries.other': 'przykłady uniwersalne – doprecyzuj branżę w opisie kursu.',
    'tutorial.form.onboarding.descs.targetGroups.business_owners': 'perspektywa całej firmy: koszty, zyski, decyzje i delegowanie.',
    'tutorial.form.onboarding.descs.targetGroups.ceo': 'strategia, wskaźniki i decyzje zarządcze – zwięźle, bez szczegółów wykonawczych.',
    'tutorial.form.onboarding.descs.targetGroups.managers': 'organizacja pracy zespołu, delegowanie, kontrola i raportowanie.',
    'tutorial.form.onboarding.descs.targetGroups.sales': 'praktyka sprzedaży: rozmowy, obiekcje, prowadzenie klienta.',
    'tutorial.form.onboarding.descs.targetGroups.hr': 'rekrutacja, onboarding, rozwój i komunikacja z pracownikami.',
    'tutorial.form.onboarding.descs.targetGroups.marketing': 'kampanie, kanały komunikacji i mierzenie efektów.',
    'tutorial.form.onboarding.descs.targetGroups.developers': 'więcej szczegółów technicznych, przykłady kodu i konfiguracji.',
    'tutorial.form.onboarding.descs.targetGroups.freelancers': 'praca na własny rachunek: pozyskiwanie klientów, wycena, organizacja czasu.',
    'tutorial.form.onboarding.descs.targetGroups.employees': 'codzienne zadania i procedury, prosty i praktyczny język.',
    'tutorial.form.onboarding.descs.lessonMinutes.3': 'pigułka wiedzy: jedna myśl, krótki tekst, ewentualnie jedno pytanie.',
    'tutorial.form.onboarding.descs.lessonMinutes.5': 'krótka lekcja: jedno zagadnienie z przykładem.',
    'tutorial.form.onboarding.descs.lessonMinutes.10': 'standardowa lekcja: wyjaśnienie, przykład i krótkie ćwiczenie.',
    'tutorial.form.onboarding.descs.lessonMinutes.15': 'pełna lekcja z kilkoma przykładami i zadaniem.',
    'tutorial.form.onboarding.descs.lessonMinutes.20': 'rozbudowana lekcja: teoria, przykłady i ćwiczenie praktyczne.',
    'tutorial.form.onboarding.descs.lessonMinutes.30': 'moduł warsztatowy z dłuższym zadaniem do wykonania.',
    'tutorial.form.onboarding.descs.lessonMinutes.45': 'blok szkoleniowy: kilka zagadnień, case study i ćwiczenia.',
    'tutorial.form.onboarding.descs.lessonMinutes.60': 'pełna sesja jak na zajęciach na żywo – dużo materiału i praktyki.',
    'tutorial.form.onboarding.descs.intensities.micro_learning': 'krótkie porcje na kilka minut dziennie, minimum teorii, szybkie quizy.',
    'tutorial.form.onboarding.descs.intensities.standard': 'zrównoważony kurs: wyjaśnienia, przykłady i ćwiczenia w umiarkowanej ilości.',
    'tutorial.form.onboarding.descs.intensities.academy': 'systematyczny, pełny program – więcej teorii, materiałów dodatkowych i sprawdzianów.',
    'tutorial.form.onboarding.descs.intensities.masterclass': 'intensywny kurs ekspercki – pogłębione treści, case studies i wymagające zadania.',
    'tutorial.form.onboarding.descs.styles.expert': 'merytorycznie i precyzyjnie, z odwołaniem do dobrych praktyk i danych.',
    'tutorial.form.onboarding.descs.styles.business': 'nacisk na efekty, liczby i korzyści dla firmy.',
    'tutorial.form.onboarding.descs.styles.formal': 'uporządkowany, oficjalny język bez kolokwializmów.',
    'tutorial.form.onboarding.descs.styles.practical': 'mniej teorii, więcej instrukcji „zrób to tak” i gotowych przykładów.',
    'tutorial.form.onboarding.descs.styles.coaching': 'pytania do refleksji i zadania prowadzące do samodzielnych wniosków.',
    'tutorial.form.onboarding.descs.styles.storytelling': 'treść prowadzona przez historie i bohaterów, z którymi uczestnik się utożsamia.',
    'tutorial.form.onboarding.descs.styles.mentoring': 'rady doświadczonego praktyka, wskazówki i typowe błędy.',
    'tutorial.form.onboarding.descs.styles.workshop': 'lekcje zbudowane wokół ćwiczeń – teoria tylko tyle, ile potrzeba do zadania.',
    'tutorial.form.onboarding.descs.tones.professional': 'rzeczowo i uprzejmie, w neutralnej formie.',
    'tutorial.form.onboarding.descs.tones.friendly': 'bezpośrednio, na „Ty”, ciepło i motywująco.',
    'tutorial.form.onboarding.descs.tones.dynamic': 'krótkie zdania, energia i wezwania do działania.',
    'tutorial.form.onboarding.descs.tones.premium': 'elegancko i z wyczuciem – podkreśla wartość i wyjątkowość kursu.',
    'tutorial.form.onboarding.descs.tones.corporate': 'oficjalny język organizacji, zgodny z jej procedurami i standardami.',
    'tutorial.form.onboarding.descs.materials.outline': 'plan kursu: kroki, sekcje i cel każdej lekcji.',
    'tutorial.form.onboarding.descs.materials.full_lessons': 'gotowe teksty wszystkich sekcji do opublikowania w kursie.',
    'tutorial.form.onboarding.descs.materials.presentations': 'slajdy do każdego kroku – do prowadzenia zajęć lub pobrania.',
    'tutorial.form.onboarding.descs.materials.pdf': 'materiały z treścią lekcji do pobrania i wydruku.',
    'tutorial.form.onboarding.descs.materials.workbook': 'zeszyt ćwiczeń wypełniany przez uczestnika w trakcie kursu.',
    'tutorial.form.onboarding.descs.materials.checklists': 'listy kontrolne do szybkiego zastosowania wiedzy w praktyce.',
    'tutorial.form.onboarding.descs.materials.quizzes': 'krótkie pytania sprawdzające po sekcjach lub krokach.',
    'tutorial.form.onboarding.descs.materials.exams': 'rozbudowane testy podsumowujące kroki lub cały kurs.',
    'tutorial.form.onboarding.descs.materials.certificate': 'wzór certyfikatu ukończenia z nazwą kursu.',
    'tutorial.form.onboarding.descs.materials.practical_tasks': 'polecenia do wykonania dołączane do sekcji jako zadania.',
    'tutorial.form.onboarding.descs.materials.worksheets': 'szablony i tabele do samodzielnej pracy uczestnika.',
    'tutorial.form.onboarding.descs.materials.prompt_pack': 'zestaw gotowych promptów AI powiązanych z tematem kursu.',
    'tutorial.form.onboarding.descs.materials.case_study': 'opisy rzeczywistych sytuacji z analizą i pytaniami.',
    'tutorial.form.onboarding.descs.materials.landing_page': 'treść strony sprzedażowej kursu: korzyści, program, FAQ.',
    'tutorial.form.onboarding.descs.materials.sales_webinar': 'scenariusz webinaru promującego kurs.',
    'tutorial.form.onboarding.descs.materials.email_campaign': 'sekwencja maili promujących kurs lub wspierających naukę.',
    'tutorial.form.onboarding.descs.materials.social_posts': 'gotowe posty zapowiadające i promujące kurs.',
    'tutorial.form.onboarding.descs.materials.meta_ads': 'teksty reklam na Facebooka i Instagrama.',
    'tutorial.form.onboarding.descs.materials.google_ads': 'nagłówki i opisy reklam w wyszukiwarce Google.',
    'tutorial.form.onboarding.goals.knowledge': 'Zdobycie wiedzy',
    'tutorial.form.onboarding.goals.skills': 'Zdobycie umiejętności',
    'tutorial.form.onboarding.goals.certification': 'Certyfikacja',
    'tutorial.form.onboarding.goals.process_implementation': 'Wdrożenie procesu',
    'tutorial.form.onboarding.goals.sales_increase': 'Zwiększenie sprzedaży',
    'tutorial.form.onboarding.goals.company_automation': 'Automatyzacja firmy',
    'tutorial.form.onboarding.goals.career_growth': 'Rozwój kariery',
    'tutorial.form.onboarding.goals.exam_preparation': 'Przygotowanie do egzaminu',
    'tutorial.form.onboarding.levels.beginner': 'Początkujący',
    'tutorial.form.onboarding.levels.intermediate': 'Średniozaawansowany',
    'tutorial.form.onboarding.levels.advanced': 'Zaawansowany',
    'tutorial.form.onboarding.levels.expert': 'Ekspert',
    'tutorial.form.onboarding.industries.b2b': 'B2B',
    'tutorial.form.onboarding.industries.ecommerce': 'E-commerce',
    'tutorial.form.onboarding.industries.services': 'Usługi',
    'tutorial.form.onboarding.industries.production': 'Produkcja',
    'tutorial.form.onboarding.industries.accounting': 'Księgowość',
    'tutorial.form.onboarding.industries.it': 'IT',
    'tutorial.form.onboarding.industries.education': 'Edukacja',
    'tutorial.form.onboarding.industries.real_estate': 'Nieruchomości',
    'tutorial.form.onboarding.industries.medicine': 'Medycyna',
    'tutorial.form.onboarding.industries.other': 'Inne',
    'tutorial.form.onboarding.targetGroups.business_owners': 'Właściciele firm',
    'tutorial.form.onboarding.targetGroups.ceo': 'CEO',
    'tutorial.form.onboarding.targetGroups.managers': 'Managerowie',
    'tutorial.form.onboarding.targetGroups.sales': 'Handlowcy',
    'tutorial.form.onboarding.targetGroups.hr': 'HR',
    'tutorial.form.onboarding.targetGroups.marketing': 'Marketing',
    'tutorial.form.onboarding.targetGroups.developers': 'Programiści',
    'tutorial.form.onboarding.targetGroups.freelancers': 'Freelancerzy',
    'tutorial.form.onboarding.targetGroups.employees': 'Pracownicy',
    'tutorial.form.onboarding.intensities.micro_learning': 'Mikro-learning',
    'tutorial.form.onboarding.intensities.standard': 'Standard',
    'tutorial.form.onboarding.intensities.academy': 'Akademia',
    'tutorial.form.onboarding.intensities.masterclass': 'Masterclass',
    'tutorial.form.onboarding.styles.expert': 'Ekspercki',
    'tutorial.form.onboarding.styles.business': 'Biznesowy',
    'tutorial.form.onboarding.styles.formal': 'Formalny',
    'tutorial.form.onboarding.styles.practical': 'Praktyczny',
    'tutorial.form.onboarding.styles.coaching': 'Coachingowy',
    'tutorial.form.onboarding.styles.storytelling': 'Storytelling',
    'tutorial.form.onboarding.styles.mentoring': 'Mentoringowy',
    'tutorial.form.onboarding.styles.workshop': 'Warsztatowy',
    'tutorial.form.onboarding.tones.professional': 'Profesjonalny',
    'tutorial.form.onboarding.tones.friendly': 'Przyjazny',
    'tutorial.form.onboarding.tones.dynamic': 'Dynamiczny',
    'tutorial.form.onboarding.tones.premium': 'Premium',
    'tutorial.form.onboarding.tones.corporate': 'Korporacyjny',
    'tutorial.form.onboarding.materials.outline': 'Konspekt',
    'tutorial.form.onboarding.materials.full_lessons': 'Pełne treści lekcji',
    'tutorial.form.onboarding.materials.presentations': 'Prezentacje',
    'tutorial.form.onboarding.materials.pdf': 'PDF',
    'tutorial.form.onboarding.materials.workbook': 'Zeszyt ćwiczeń',
    'tutorial.form.onboarding.materials.checklists': 'Checklisty',
    'tutorial.form.onboarding.materials.quizzes': 'Quizy',
    'tutorial.form.onboarding.materials.exams': 'Egzaminy',
    'tutorial.form.onboarding.materials.certificate': 'Certyfikat',
    'tutorial.form.onboarding.materials.practical_tasks': 'Zadania praktyczne',
    'tutorial.form.onboarding.materials.worksheets': 'Arkusze robocze',
    'tutorial.form.onboarding.materials.prompt_pack': 'Prompt Pack',
    'tutorial.form.onboarding.materials.case_study': 'Case Study',
    'tutorial.form.onboarding.materials.landing_page': 'Landing Page',
    'tutorial.form.onboarding.materials.sales_webinar': 'Webinar sprzedażowy',
    'tutorial.form.onboarding.materials.email_campaign': 'Kampania e-mail',
    'tutorial.form.onboarding.materials.social_posts': 'Posty social media',
    'tutorial.form.onboarding.materials.meta_ads': 'Reklamy Meta',
    'tutorial.form.onboarding.materials.google_ads': 'Reklamy Google',
    'tutorial.form.onboarding.imageStyles.photorealistic': 'Fotorealistyczne',
    'tutorial.form.onboarding.imageStyles.corporate': 'Corporate',
    'tutorial.form.onboarding.imageStyles.minimalist': 'Minimalistyczne',
    'tutorial.form.onboarding.imageStyles.3d': '3D',
    'tutorial.form.onboarding.imageStyles.infographic': 'Infografiki',
    'tutorial.form.onboarding.imageStyles.comic': 'Komiks',
    'tutorial.form.onboarding.imageStyles.premium': 'Premium',
    'tutorial.form.sourcePreview': 'Podgląd źródła',
    'tutorial.form.editor.formEditor': 'Edytor formularza',
    'tutorial.form.editor.formIncluded': 'Formularz dodany',
    'tutorial.form.editor.quiz': 'Quiz',
    'tutorial.form.editor.answer': 'Odpowiedź',
    'tutorial.form.editor.addField': 'Dodaj pole',
    'tutorial.form.editor.addOption': 'Dodaj opcję',
    'tutorial.form.editor.fieldType': 'Typ pola',
    'tutorial.form.editor.label': 'Etykieta',
    'tutorial.form.editor.max': 'Maks.',
    'tutorial.form.editor.min': 'Min.',
    'tutorial.form.editor.moveDown': 'Przesuń w dół',
    'tutorial.form.editor.moveUp': 'Przesuń w górę',
    'tutorial.form.editor.multiple': 'Wielokrotny wybór',
    'tutorial.form.editor.name': 'Nazwa',
    'tutorial.form.editor.optionLabel': 'Etykieta opcji',
    'tutorial.form.editor.optionValue': 'Wartość opcji',
    'tutorial.form.editor.options': 'Opcje',
    'tutorial.form.editor.placeholder': 'Tekst zastępczy',
    'tutorial.form.editor.remove': 'Usuń',
    'tutorial.form.editor.required': 'Wymagane',
    'tutorial.form.editor.rows': 'Liczba wierszy',
    'tutorial.form.editor.showValue': 'Pokaż wartość',
    'tutorial.form.editor.step': 'Krok',
    'tutorial.form.editor.submitLabel': 'Etykieta przycisku wysyłania',
    'tutorial.form.editor.type': 'Typ',
    'tutorial.form.editor.unit': 'Jednostka',
    'tutorial.form.editor.fieldType.input': 'Pole tekstowe',
    'tutorial.form.editor.fieldType.textarea': 'Obszar tekstowy',
    'tutorial.form.editor.fieldType.select': 'Lista rozwijana',
    'tutorial.form.editor.fieldType.radio': 'Przyciski opcji',
    'tutorial.form.editor.fieldType.checkbox': 'Pole wyboru',
    'tutorial.form.editor.fieldType.date': 'Data',
    'tutorial.form.editor.fieldType.switch': 'Przełącznik',
    'tutorial.form.editor.fieldType.slider': 'Suwak',
    'tutorial.form.editor.inputFieldType.text': 'Tekst',
    'tutorial.form.editor.inputFieldType.number': 'Liczba',
    'tutorial.form.editor.inputFieldType.email': 'E-mail',
    'tutorial.form.editor.inputFieldType.password': 'Hasło',
    'tutorial.form.editor.inputFieldType.tel': 'Telefon',
    'tutorial.form.editor.inputFieldType.url': 'URL',
    'tutorial.form.editor.inputFieldType.search': 'Wyszukiwanie',
    'tutorial.form.editor.inputFieldType.date': 'Data',
    'tutorial.form.editor.inputFieldType.datetime-local': 'Data i godzina',
    'tutorial.form.editor.inputFieldType.time': 'Godzina',
    'tutorial.form.editor.defaultSubmitLabel': 'Wyślij',
    'tutorial.form.editor.defaultFieldLabel': 'Nowe pole',
    'tutorial.form.editor.defaultOptionLabel': 'Opcja {index}',
    'tutorial.form.editor.saveForm': 'Zapisz formularz',
    'tutorial_form.optinfo.placeholder': 'Wskaż opcję, aby zobaczyć, na co wpływa w kursie.',
    'tutorial.form.editor.draft_info': 'To jest szkic szkolenia. Żeby było widoczne dla uczestników, musisz je opublikować.',
};
